import React, { useEffect, useState } from "react";

import { useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import HomeIcon from '@material-ui/icons/Home';
import { Tabs, Tab, Grid, FormControlLabel } from "@material-ui/core";
import { useHistory} from 'react-router-dom'
import { Telegram } from "@material-ui/icons";
import AssignmentIcon from '@material-ui/icons/Assignment';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import WorkIcon from '@material-ui/icons/Work';
import ReactTooltip from "react-tooltip";

import resumeData from "../../utils/resumeDate"
import useStyles from "./style";



const Header = (props) => {

  const classes = useStyles()
  const history = useHistory()
  const theme = useTheme(); 
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [value, setValue] = useState(0)

  useEffect(() => {
    if(value === 0)  history.push("/")
    else if(value === 1) history.push("/resume")
    else if(value === 2) history.push("/portfolio")
    else if(value === 3) history.push("/contact")
  }, [value,history])

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  return (
    <div >
      <AppBar  color="transparent" position="static">
        <Toolbar className={classes.header}>
          {isMobile ? (
            <>
            <Grid container justify="space-evenly">
              <Tabs
                onChange={handleChange}
                className={classes.mobileTabsContainer}
                indicatorColor="white"
                value={value}
              >
                <Tab
                  data-tip data-for="Home"
                  icon={<HomeIcon fontSize="large" />}
                  className={classes.mobileTab}
                  disableRipple={true}
                  disableFocusRipple={true}
                  value={0}
                />
                <Tab
                  data-tip data-for="Resume"
                  disableRipple={true}
                  disableFocusRipple={true}
                  className={classes.mobileTab}
                  icon={<AssignmentIcon fontSize="large" />} 
                  value={1}
                />
                <Tab
                  data-tip data-for="Project"
                  disableRipple={true}
                  disableFocusRipple={true}
                  className={classes.mobileTab}
                  icon={<WorkIcon fontSize="large" />}
                  value={2}
                />
                <Tab
                  data-tip data-for="Contact"
                  className={classes.mobileTab}
                  disableFocusRipple={true}
                  disableRipple={true}
                  icon={<PermContactCalendarIcon fontSize="large" />}
                  value={3}
                />
              </Tabs>
            </Grid>
              
            </>
          ) : (
            <div className={classes.desktopHeader } >
              <Tabs
                onChange={handleChange}
                className={classes.tabsContainer}
                indicatorColor="white"
                value={value}>
                <Tab
                  icon={<HomeIcon />}
                  className={classes.icon}
                  disableRipple = {true}
                  disableFocusRipple	={true}
                  value={0}
                />
                <Tab
                  disableRipple = {true}
                  disableFocusRipple	={true}
                  className={classes.tab}
                  label='Resume'
                  value={1}
                />
                <Tab
                  disableRipple = {true}
                  disableFocusRipple	={true}
                  className={classes.tab}
                  label='Portfolio'
                  value={2}
                />
                <Tab
                className={classes.tab}
                disableFocusRipple	={true}
                disableRipple = {true}
                  label='Contact'
                  value={3}
                />

                <div className={classes.socialHeader}>

                  {Object.keys (resumeData.socials).map (key => (
                    <Grid item className={classes.contactInfoSocial}>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        className={classes.a}
                        href={resumeData.socials[key].link}
                      >
                        {resumeData.socials[key].icon}
                      </a>
                    </Grid>
                  ))}

                  <FormControlLabel control={
                      <a target="_top"
                      style={{textDecoration: "none"}}
                      href="mailto:smitshah9102000@gmail.com">
                        <Button className={classes.btn} endIcon={ <div className={classes.btnicon}> <Telegram /> </div> }> <span className={classes.text}> Hire Me </span> </Button>
                      </a>
                    }
                  />

                </div>
                
              </Tabs>
            </div>
          )}
        </Toolbar>
      </AppBar>
      <ReactTooltip id="Home" place="top" effect="solid">
        Home
      </ReactTooltip>
      <ReactTooltip id="Resume" place="top" effect="solid">
        Resume
      </ReactTooltip>
      <ReactTooltip id="Project" place="top" effect="solid">
        Portfolio
      </ReactTooltip>
      <ReactTooltip id="Contact" place="top" effect="solid">
        Contact
      </ReactTooltip>
    </div>
  );
};
export default Header